<template>
  <div :class="{'move-mode': itemToMove}">
    <!-- <div class="search" v-if="!itemToMove">
      <span class="fal fa-search fa-lg"></span>
      <input type="text" name="search" v-model="search" placeholder="Search this folder"/>
    </div> -->
    <Search @searcher="onSearch" :placeholder="'Search this folder'">
    </Search>

    <!-- BREADCRUMB -->
    <div class="folder-breadcrumbs" v-if="foldersFlatMap">
      <slot v-if="currentFolder.breadcrumbs && currentFolder.breadcrumbs.length > 0">
        <a @click="navFolder(foldersFlatMap['myfolders'])" class="home-link"><span class="fas fa-home"></span> Home</a>
        <span v-for='(breadcrumbFolderId, i) in currentFolder.breadcrumbs' v-bind:key="i" class='folder-breadcrumb'>
          <span class='fal fa-arrow-right'></span><!--<span class="fal fa-folder"></span>-->
          <a v-if='i < currentFolder.breadcrumbs.length - 1' @click="navFolder(foldersFlatMap[breadcrumbFolderId])" class='folder-breadcrumb-link'>
            {{foldersFlatMap[breadcrumbFolderId].title}}&nbsp;
          </a>
          <span v-else class="folder-breadcrumb-nolink">{{foldersFlatMap[breadcrumbFolderId].title}}</span>
        </span>
      </slot>
      <slot v-else >
        <span>
          <span class="fas fa-home"></span> Home
        </span>
      </slot>
    </div>
    
    <!-- DESCRIPTION -->
    <div v-if="!itemToMove">
      <div v-show="!editDescriptionMode" class="folder-description">
        <div v-on:click.stop="descriptionFocus()" class="description-text" v-html="currentFolder.desc ? utils.nl2br(currentFolder.desc) : ''" />
        <span v-on:click="descriptionFocus()" title="Edit description" class="icon-button is-vcentered">
          <i class="fal fa-pencil"></i>
        </span>
      </div>
      <div v-show="editDescriptionMode" class="folder-description">
        <form v-on:submit.prevent="updateDescription();">
          <textarea ref="description" v-model="currentFolder.desc" v-on:blur="updateDescription()" class="textarea"></textarea>
        </form>
        <span @click=";" title="Save description" class="icon-button is-vcentered">
          <i class="fal fa-check"></i>
        </span>
      </div>
    </div>

    <!-- FOLDERS -->
    <div v-if="!currentFolder" class="no-content-message">
      The URL specified is no longer valid. Please navigate using the menu at the top.
    </div>
    <div v-else class="folder-content" :style="maxHeight ? 'max-height: ' + maxHeight + '; overflow: scroll' : ''">
      <div v-if="searchedFolders.length === 0 && searchedResources.length === 0" class="no-content-message">
        There is currently no content to display.
      </div>
      <div v-for="(folder, i) in searchedFolders" v-bind:key="'folder' + i" :class="{'disabled': itemToMove && itemToMove.folderId === folder.folderId}" class='list-item'>
        <div class='folder-title' @click="if(!itemToMove || itemToMove.folderId !== folder.folderId) navFolder(folder)">
          <div class='img-middle'>
            <div class="fas fa-folder"></div>
          </div>
          <div class="item-folder">{{folder.title}}</div>
        </div>
        <Popover content="popover" :ref="folder.folderId" placement="bottom" class="is-pulled-right" v-if="!itemToMove">
          <div class="button popover-btn"><i class="fa fa-ellipsis-v"></i></div>
          <div slot="content">
            <div class="list-item" v-for="action in folderActionItems" :key="action" v-on:click.stop="subfolderAction(action, folder); $refs[folder.folderId][0].hidePopper();">
              <span class="action-item">{{action}}</span>
            </div>
          </div>
        </Popover>
      </div>

      <!-- RESOURCES -->
      <slot v-if="!itemToMove">
        <div v-for="(resource, i) in searchedResources" v-bind:key="'res' + i" :ref="resource.id + '-div'" >
          <div v-if="resource.id" class="list-item">
            <div class='folder-title' @click="openResource(resource)">
              <div class="img-middle">
                <img :src="getResourceImgPath(resource)" />
              </div> 
              <div class="item-resource">
                <span class="resource-title">{{resource.title}}</span>
                <span class="added-on">Added on {{addedOnText(resource.created)}}</span>
              </div>
              <loading :small="true" v-if="resource.uploading" class="resource-uploading"/>
            </div>
            <Popover content="popover" :ref="resource.id" placement="bottom" class="is-pulled-right">
              <div class="button popover-btn" v-bind:ref="searchedResources.id"><i class="fa fa-ellipsis-v"></i></div>
              <div slot="content">
                <slot v-if="resource.type == 'flashcarddeck'">
                  <div class="list-item" v-for="(action) in fileActionItems['flashcarddeck']" :key="action" v-on:click.stop="resourceAction(action, resource); $refs[resource.id][0].hidePopper();">
                    <span class="action-item">{{action}}</span>
                  </div>
                </slot>
                <slot v-else>
                  <div class="list-item" v-for="(action) in fileActionItems['null']" :key="action" v-on:click.stop="resourceAction(action, resource); $refs[resource.id][0].hidePopper();">
                    <span class="action-item">{{action}}</span>
                  </div>
                </slot>
              </div>
            </Popover>
          </div>
        </div>
      </slot>
    </div>    
  </div>  
</template>

<script>
  const _ = require('lodash');
  const moment = require('moment');
  require('moment-timezone');
  moment.tz.setDefault('Africa/Johannesburg');
  
  import Vue from 'vue';
  import utils from '@/utils/utils.js';
  import Popover from '@/components/widgets/popover'
  import Search from '@/components/widgets/Search';
  import storeHelpers from '@/utils/storeHelpers.js';

  export default {
    name: 'FolderView',
    components: {
      Popover,
      Search
    },
    props: [
      'currentFolder',
      'descriptionUpdated',
      'navFolder',
      'foldersFlatMap',
      'subfolderAction',
      'resourceAction',
      'itemToMove',
      'maxHeight'
    ],
    data: function () {
      var t = this;

      return {
        editDescriptionMode: false,
        search: '',
        utils: utils,
        folderActionItems: ["Rename", "Move", "Delete"],
        fileActionItems: {
          "flashcarddeck": ["Move", "Delete", "Edit"],
          "null": ["Rename", "Move", "Delete", "Download"], //"Copy to Clipboard"
        },
        contextMenu: {
          el: undefined,
          menuVisible: false
        },
      }
    },
    computed: {
      searchedFolders() {
        return _.orderBy(this.currentFolder.children, [function(folder) { return folder.title.trim().toLowerCase() }], ['asc']).filter(folder => {
          return folder.title.toLowerCase().includes(this.search.toLowerCase())
        })
      },
      searchedResources() {
        return _.orderBy(this.currentFolder.resources, [function(resource) { return resource.title.trim().toLowerCase() }], ['asc']).filter(resource => {
          return resource.title.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    },
    mounted: function () {
      if(!this.currentFolder.desc) {
        this.currentFolder.desc = "a";
      }
      var t = this;
      document.addEventListener("keydown", function(e) {
        if (e.keyCode === 27 && t.editDescriptionMode) {
          t.updateDescription();
        }
      });
    },
    methods: {
      onSearch: function(val) {
        this.search = val;
      },
      openResource(resource) {
        utils.openResource(this, resource)
      },
      getResourceImgPath: function(resource) {
        // if the resource type is missing for some reason (e.g. Windows sets it as null), go look it up
        if(!resource.type) {
          var resourceFound = storeHelpers.getResourceById(this, resource.id);          
          if(resourceFound) {
            resource.type = resourceFound.category;
          }
        }
        return this.$config.get('basePathFiles') + (utils.resourceTypeImg(resource.type))
      },
      descriptionFocus: function() {
        var t = this;

        t.editDescriptionMode = true;

        Vue.nextTick(function(){
          t.$refs.description.focus();
        });
      },
      updateDescription: function() {
        this.descriptionUpdated();
        this.editDescriptionMode = false;
      },
      addedOnText: function(created) {
        var date = new Date(created * 1000);
        return date.getDate() + " " + date.toLocaleString('default', { month: 'long' }) + " " + date.getFullYear();
        // return date;
      }
    }
  }

</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.content .fa-arrow-right {
  color: $primary-color; 
  font-size: 10pt; 
}

.folder-content {
  .list-item {
    display: table;
    padding: 7px;

    .folder-title, .popover-btn {
      display: table-cell;
    }

    .popover-btn {
      padding: 10px;
    }

    .folder-title {
      width: 100%;

      .item-folder {
        vertical-align: top;
        display: inline-block;
        margin-top: 10px;
        margin-left: 5px;
        max-width: calc(100vw - 140px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .item-resource {
        vertical-align: top;
        display: inline-block;
        margin-left: 5px;
        max-width: calc(100vw - 140px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        .resource-title {
          display: block;
        }

        .added-on {
          display: block;
          font-size: 10pt;
          font-weight: 400;
          color: $dark-font-color-lighter;
        }
      }
    }

    .resource-uploading {
      position: relative;
      top: -5px;
      left: 20px;
    }
  }

  .fa-folder {
    color: $primary-color; 
    font-size: 26pt; 
    display: inline-block;
  }
}

.search {
  margin-top: 30px;
}

.folder-breadcrumbs {
  text-align: left; 
  margin-bottom: 10px;
  margin-top: 20px;
}

.folder-breadcrumb-link {
  display: inline-block;
  padding: 0 5px;
}

.folder-breadcrumb-nolink {
  margin-left: 5px;
  display: inline-block;
}

.home-link {
  margin-right: 5px;
  display: inline-block;
}

.list-item > .item {
  vertical-align: top;
  margin-top: 10px;
  margin-left: 10px;
  display: inline-block;
}

.list-item.disabled .fa-folder {
  color: $primary-color-disabled;
}

.move-mode .popover-btn {
  display: none;
}

.img-middle {
  width: 32px;
  height: 32px;
  margin: 5px;
  display: inline-block;
  position: relative;
}

.folder-description {
  color: $dark-font-color-lighter;
  text-align: left;
  padding: 0 0 10px;
  font-size: 11pt;
  display: table;
  width: 100%;
}

.folder-description > * {
  display: table-cell;
}

.folder-description > span {
  width: 30px;
}

.folder-description .fal {
  font-size: 14pt;
}

.folder-actions, .resource-actions {
  margin-right: 5px;
  margin-top: 4px;
  padding: 6px 15px;
  border-radius: 50%;
}

.folder-actions:hover, .resource-actions:hover {
  background: $button-on-hover-color;
}

.folder-actions:active, .resource-actions:active {
  background: $button-on-click-color;
}

.description-text {
  width: 96%;
  display: inline-block;
  margin-right: 1px;
}

.description-text:focus {
  outline: 0px solid transparent;
}

.description-icon:hover {
  cursor: pointer;
}

.folder-breadcrumbs .fa-home {
  margin-right: 4px;
}

.textarea {
  width: calc(100% - 20px);
  min-width: 100px;
}



@media only screen and (max-width: 900px) {
  .description {
    width: 95%;
  }
}

@media only screen and (max-width: 700px) {
  .description {
    width: 92%;
  }
}

@media only screen and (max-width: 500px) {
  .description {
    width: 90%;
  }
}
</style>